import type { LessonViewStatus } from '../viewModels/learningPath'
import styles from './StatusMarker.module.css'

const LABELS: Record<LessonViewStatus, string> = {
  completed: 'Completed',
  'in-progress': 'In progress',
  available: 'Available',
  upcoming: 'Upcoming',
}

const GLYPHS: Record<LessonViewStatus, string> = {
  completed: '✓',
  'in-progress': '•',
  available: '→',
  upcoming: '',
}

/**
 * A compact, non-color-only status indicator. Each status pairs a distinct
 * glyph with a text label so meaning does not rely on color alone.
 */
export function StatusMarker({ status }: { status: LessonViewStatus }) {
  return (
    <span className={`${styles.marker} ${styles[status]}`}>
      <span className={styles.dot} aria-hidden="true">
        {GLYPHS[status]}
      </span>
      {LABELS[status]}
    </span>
  )
}
